var React = require('react');

function Euro (props) {
    return React.createElement("svg",props,React.createElement("text",{"data-name":"€","transform":"translate(11 24)","fill":"currentColor","fontSize":"25","fontFamily":"Montserrat-SemiBold, Montserrat","fontWeight":"600","letterSpacing":"0.01em"},React.createElement("tspan",{"x":"-10.163","y":"0"},"€")));
}

Euro.defaultProps = {"width":"22","height":"30","viewBox":"0 0 22 30"};

module.exports = Euro;

Euro.default = Euro;
